(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DialyserTypeDeleteController',DialyserTypeDeleteController);

    DialyserTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'DialyserType'];

    function DialyserTypeDeleteController($uibModalInstance, entity, DialyserType) {
        var vm = this;

        vm.dialyserType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DialyserType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
